import { useContext, useEffect, useState } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { BrowsePriceMenu } from "./BrowsePriceMenu";
import { useRouter } from "next/router";
import { Context, getSearchResults, getWatermarkedImgixUrl } from "services";

export default function BrowseByPrice() {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  const [propertiesByPrice, setPropertiesByPrice] = useState<any[]>([]);

  const init = async () => {
    const data: any = await getSearchResults({
      searches: [
        {
          collection: "properties",
          q: "*",
          query_by: "",
          facet_by: "dump.price_category.slug",
          facet_return_parent: "dump.price_category.slug",
          filter: "true",
          filter_by: `status:active && property_date_type:=dated ${
            searchForm?.value?.city?.label === "All Cities"
              ? ""
              : `&& dump.location.city_name:=${searchForm?.value?.city?.label}`
          }`,
          max_facet_values: "100",
          per_page: 250,
          sort_by: "auction_start_date_unix_timestamp:asc",
        },
      ],
    });

    const mapHitsToChildren = (hits: any[]) => {
      return (
        hits.map((hit: any, index: number) => ({
          subAssetType: hit.document.dump.asset.sub_asset_type_name,
          price: hit.document.reserve_price,
          address: hit.document.dump.location.locality_name
            ? `${hit.document.dump.location.locality_name}, ${hit.document.dump.location.city_name}`
            : hit.document.dump.location.city_name,
          imageLink: hit.document?.dump?.property_image
            ? getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${hit.document?.dump?.property_image}`,
              )
            : hit.document?.dump?.asset?.placeholder_image
            ? getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${hit?.document?.dump?.asset?.placeholder_image}`,
              )
            : `/residential${(index % 3) + 1}.png`,
          propertyLink: `/auction-properties/${hit.document.listing_id}`,
        })) || []
      );
    };

    const filteredPropertiesData = [
      {
        title: "All",
        value: "all",
        children: mapHitsToChildren(
          data.results[0]?.hits?.length > 0 ? data.results[0].hits : [],
        ),
      },
      ...((data.results[0]?.facet_counts &&
        data.results[0]?.facet_counts[0]?.counts.map((facet: any) => {
          const hits = data?.results[0]?.hits?.length
            ? data.results[0].hits
            : [];
          const children = hits.filter(
            (hit: any) =>
              hit.document.dump.price_category.slug === facet.parent.slug,
          );

          return {
            title: facet.parent.name,
            value: facet.parent.slug,
            children: mapHitsToChildren(children),
          };
        })) ||
        []),
    ];
    setPropertiesByPrice(filteredPropertiesData);
  };

  useEffect(() => {
    (async () => {
      await init();
    })();
  }, [searchForm.value.city]);

  return propertiesByPrice?.[0]?.children?.length > 0 ? (
    <>
      <div className=" lg:hidden ">
        <div className="w-full px-4 lg:px-customPadding mt-4 lg:mt-20 py-[42px] lg:py-[50px] 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0 ">
          {/* Heading */}
          <div className="flex items-center pr-10 lg:pr-0">
            <p className=" font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h2 leading-9 lg:leading-[57px] text-brand-textBlack">
              BROWSE PROPERTIES BY PRICE
            </p>
          </div>
          {/* Cards */}
          <div className="mt-6 lg:mt-[70px] ">
            <BrowsePriceMenu propertiesByPrice={propertiesByPrice} />
          </div>

          <div className="pr-4 w-full mt-[52px]  flex justify-center">
            <Button
              className=" w-[350px] h-10"
              onClick={() =>
                router.push(
                  `${
                    searchForm?.value?.city?.value
                      ? `/auction-properties-in-${searchForm?.value?.city?.value}`
                      : `/auction-properties`
                  }`,
                )
              }
            >
              <p className="font-openSans font-semibold text-mobile-body-md  leading-4  text-brand-textWhite">
                View all
              </p>
            </Button>
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
